import { render } from "./Ingredients.vue?vue&type=template&id=3ddf99f6&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"

import "./Ingredients.vue?vue&type=style&index=0&id=3ddf99f6&scoped=true&lang=css"

import exportComponent from "E:\\Github\\Vue\\drinks\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddf99f6"]])

export default __exports__